import styled, { css } from "styled-components";
export const SessionWrapper = styled.section `
	height: 60px;
	overflow: hidden;
	position: relative;
	margin: 12px auto 0 auto;

	${(props) => {
    if (props.isFixed) {
        return css `
				position: fixed;
				top: ${props.scrollTop || 0}px;
				left: 0;
				margin: 0 auto;
				z-index: 2;
				width: 100vw;
			`;
    }
    return css ``;
}}
`;
export const Session = styled.section `
	height: 60px;
	background-color: #fff;
	display: flex;
	flex-direction: row;
	width: 1200px;
	margin: 0 auto;

	&.showController {
		& > i {
			display: block;
		}
	}

	& > i {
		width: 40px;
		height: 60px;
		display: none;

		background-size: 30%;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		opacity: 0.6;
		cursor: pointer;

		&:first-child {
			background-image: url("https://i.ezbuy.sg/FrGfjk_FAXXB4GiW-zGgame8Erjv");
		}
		&:last-child {
			background-image: url("https://i.ezbuy.sg/FlkScpIeXm7pdKxFyr8l5d51TEPK");
		}

		&:hover {
			opacity: 1;
			background-color: #e6e6e6;
			transition: background-color ease 100ms;
		}

		&.arrowDisabled {
			opacity: 0.3;
			cursor: default;
			pointer-events: none;
		}
	}

	& > ul {
		flex: 1;
		list-style: none;
		display: flex;
		flex-direction: row;
		overflow: hidden;
		margin: 0;
		padding: 0;

		& > li {
			flex: 1;
			height: 60px;
			min-width: 280px;
			color: #666;
			transition: transform 0.5s ease;
			text-align: center;
			cursor: pointer;
			display: flex;
			justify-content: center;
			align-items: center;
			max-width: 50%;

			&:hover {
				color: #ea2626;
			}

			&.active > div {
				color: #fff;
				background: linear-gradient(129deg, #fe456a 0%, #e61f17 100%);
			}

			& > div {
				width: 240px;
				height: 48px;
				border-radius: 2px;

				& > h1 {
					font-weight: bold;
					font-size: 18px;
					line-height: 1em;
					margin: 5px 0 0;
				}
				& > b {
					font-size: 14px;
					font-weight: 400;
					line-height: 16px;
				}
			}
		}
	}
`;
